import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
  viewChild,
} from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { Dialog, DialogModule } from 'primeng/dialog';

import { NgIconComponent } from '@ng-icons/core';

import { LoaderWrapperComponent } from '@components/loader-wrapper/loader-wrapper.component';

import { SessionService } from '@services/session/session.service';

@Component({
  selector: 'logout-dialog',
  standalone: true,
  imports: [
    CommonModule,

    DialogModule,
    ButtonModule,

    NgIconComponent,

    LoaderWrapperComponent,
  ],
  templateUrl: './logout-dialog.component.html',
  styleUrl: './logout-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutDialog {
  dialogEl = viewChild<Dialog>('dialogEl');

  visible = model(false);

  private session = inject(SessionService);

  loaderKey = 'Logout';

  logout() {
    void this.session.logout(this.loaderKey);
  }
}
